<template>
  <div>
    <TopBar :pagetitle="title" :back-url="backurl" />
    <form action="/">
      <van-search
        v-model="search.key"
        class="serBar"
        placeholder="请输入搜索关键词"
        background="#F1F1F1"
        @search="onSearch"
        @cancel="onCancel"
      />
    </form>
    <baidu-map center="北京" @ready="mapHandler" />
    <div class="serType">
      <van-dropdown-menu active-color="#E32119">
        <van-dropdown-item v-model="search.sort" :options="option1" @change="onSearch" />
        <van-dropdown-item v-model="search.course" :options="option2" @change="onSearch" />
        <van-dropdown-item v-model="search.type" :options="option3" @change="onSearch" />
      </van-dropdown-menu>
    </div>
    <van-list
      v-model="loading"
      class="listBody"
      :finished="finished"
      finished-text="没有更多了"
      @load="onLoad"
    >
      <div v-for="item in list" :key="item.shopId" class="shopRect" @click="selectShop(item.shopId)">
        <img class="icon" :src="item.icon">
        <div class="body">
          <div class="jumpButton">
            <i class="iconfont iconright rightGoto" />
          </div>
          <div class="pageTitle1 title">{{ item.title }}</div>
          <div class="pagebody3 aboutStr">{{ item.subheading }}</div>
          <div class="pagebody2 address"><i class="iconfont iconchengshi" /> {{ Math.ceil(item.distance) }}公里 </div>
          <div class="pagebody2 type"><i class="iconfont icontechdive" />
            <span v-for="oneSport in item.sport.split(',')" :key="oneSport">
              {{ $t('diveCenter.sport.'+oneSport) }}
            </span></div>
        </div>
      </div>

      <!-- <div v-for="n in 10" :key="n" class="shopRect">
        <img class="icon" src="http://intotheblue.pro/Content/img/pubbottomicon3.jpg">
        <div class="body">
          <div class="jumpButton">
            <i class="iconfont iconright rightGoto" />
          </div>
          <div class="pageTitle1 title">Cool Diving</div>
          <div class="pagebody3 aboutStr">西南优质潜水中心 东南亚多个培训基地</div>
          <div class="pagebody2 address"><i class="iconfont iconusercard" /> 1.5公里</div>
          <div class="pagebody2 type"><i class="iconfont iconusercard" /> 水肺潜水、自由潜、船宿、美人鱼、技术潜水、游泳、</div>
        </div>
      </div> -->
    </van-list>

  </div></template>
<script>
import request from '@/utils/request'
import TopBar from '@/components/TopBar'
import { initPage, getUrlKey } from '@/utils/base'
import { Button, Search, DropdownMenu, DropdownItem, List } from 'vant'
export default {
  name: 'DiveshopList',
  components: {
    [Button.name]: Button,
    [Search.name]: Search,
    [DropdownMenu.name]: DropdownMenu,
    [DropdownItem.name]: DropdownItem,
    [List.name]: List,
    TopBar
  },
  data() {
    return {
      title: '潜水中心店铺',
      backurl: '/store/index',
      isFinishLocation: false, // 获取坐标完成
      offsetTop: 0,
      search: {
        key: undefined,
        sort: 'BASE',
        course: '',
        type: '',
        lat: undefined,
        lng: undefined,
        limit: 30,
        page: 1
      },

      option1: [
        { text: '推荐排序', value: 'BASE' },
        { text: '离我最近', value: 'NEAR' },
        { text: '销量最高', value: 'SELL' },
        { text: '好评最多', value: 'COMMENT' }
      ],
      option2: [
        { text: '全部课程', value: '' },
        { text: '水肺课程', value: 'scuba' },
        { text: '美人鱼课程', value: 'mermaid' },
        { text: '自由潜课程', value: 'freediving' },
        { text: '教练课程', value: 'xr' }
      ],
      option3: [
        { text: '全部类型', value: '' },
        { text: '潜水中心', value: 'Dive Center' },
        { text: '潜水学校', value: 'Dive School' },
        { text: '自由潜中心', value: 'Freediving Center' },
        { text: '潜水船', value: 'Dive Boat' },
        { text: '美人鱼中心', value: 'Mermaid Center' }
        // Dive Center
        // Dive School
        // Administrative and Others
        // Freediving Center
        // Diving School
        // Regionalcenter
        // Dive Boat
        // Area Office
        // Snorkel Center
        // Mermaid Center
        // Swim Center
        // EX Service Center
      ],
      list: [],
      loading: false,
      finished: false
    }
  },
  created() {
    initPage(false)
    var url = getUrlKey('backurl')
    if (url !== null) {
      this.backurl = url
    }
  },
  activated() {
    initPage(false)
    // keep-alive组件 页面进入的时候设置滚动高度
    document.documentElement.scrollTop = this.offsetTop
    console.log('activated', this.offsetTop)
  },
  beforeRouteLeave(to, from, next) {
    // keep-alive 组件停用时调用（简单理解为组件离开的时候）。
    // 获取页面滚动高度，这个钩子有可能会拿不到数据，因为这个钩子执行的慢，可以用beforeRouteLeave代替
    console.log('beforeRouteLeave', this.offsetTop)
    this.offsetTop = document.documentElement.scrollTop
    next()
  },
  methods: {

    mapHandler({ BMap, map }) {
      console.log('Get {BMap, map}', map)
      var geolocation = new BMap.Geolocation()
      var selfs = this
      geolocation.getCurrentPosition(function(r) {
        if (this.getStatus() === 0) {
          selfs.search.lat = r.point.lat
          selfs.search.lng = r.point.lng
          // alert('您的位置：' + r.point.lng + ',' + r.point.lat)
        } else {
          selfs.search.lat = undefined
          selfs.search.lng = undefined
          // alert('failed' + this.getStatus())
        }
        selfs.onLoad(true)
      }, { enableHighAccuracy: true })
    },
    selectShop(shopId) {
      this.$router.replace('/store/diveshop/' + shopId)
    },
    onSearch() {
      this.list = []
      this.search.page = 1
      this.finished = false
      this.onLoad()
    },
    onCancel() {
      this.searchValue = ''
      this.list = []
      this.search.page = 1
      this.finished = false
      this.onLoad()
    },
    onLoad(isFirst) {
      if (isFirst === undefined && !this.isFinishLocation) {
        return
      }
      this.loading = true
      console.log('发起网络请求', this.search)
      request({
        url: '/Store/getShopList',
        method: 'post',
        data: this.search
      }).then(response => {
        if (isFirst) {
          this.isFinishLocation = true
        }
        if (!response.success) {
          this.error = true
          return
        }
        this.loading = false
        this.search.limit = response.data.limit
        this.search.page = response.data.page + 1
        response.data.rows.forEach(item => {
          this.list.push(item)
        })
        if (response.data.rows.length < this.search.limit) {
          this.finished = true
        }
      })
    }
  }
}
</script>
<style scoped>
.van-search__content{
    background-color: #fff ;
}
.van-dropdown-menu{
    border-top-left-radius:1em;
    border-top-right-radius:1em;
}
.serBar{
    position: fixed;
    left: 0;
    top:3em;
    width: 100%;
    height: 3.5em;
    z-index: 10;
}
.serType{
    background-color: #f1f1f1;
    position: fixed;
    left: 0;
    top:6.5em;
    height: 3em;
    width: 100%;
    z-index: 10;
}
.van-dropdown-menu{
    height: 3em;
}
.listBody{
    margin-top: 7em;
}
.shopRect{
    height: 7em;
    border: 1px solid #f1f1f1;
    margin: 0.5em 1em;
    position: relative;
}
.shopRect .title{
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    padding-right: 1.5em;
}
.shopRect .aboutStr{
    overflow: hidden;
    display: -webkit-box;
    text-overflow: ellipsis;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    margin-top: 0.3em;
}
.shopRect .address{
    margin-top: 0.5em;
}
.shopRect .type{
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    margin-top: 0.5em;
}
.shopRect .jumpButton
{
    position: absolute;
    right: 0.5em;
    top: 0.5em;
}
.shopRect .icon{
    height: 6.8em;
    padding: 0.1em;
}
.shopRect .body{
    position: absolute;
    left:7em;
    top:0;
    width: calc(100% - 8em);
    padding: 0.5em;
}

</style>
